import React from 'react';
import PropTypes from 'prop-types';
import CustomPropTypes from 'CustomPropTypes';
import StaticBuilderFormattedFields from 'StaticBuilder/StaticBuilderFormattedFields';

export default function withStaticBuilderSetup(WrappedComponent) {
  class StaticBuilderSetup extends React.Component {
    constructor(props) {
      super(props);
      this.getGroupedFields = this.getGroupedFields.bind(this);
    }

    getGroupedFields() {
      const formattedFields = new StaticBuilderFormattedFields(this.props.sectionContent);

      this.props.fields.forEach((field, idx, array) => {
        const updatedField = {
          ...field,
          options: field.options || [],
        };

        const isEndOfMultiple = idx === array.length - 1;
        formattedFields.addField(updatedField, isEndOfMultiple);
      });
      return formattedFields;
    }


    render() {
      const formattedFields = this.getGroupedFields();

      return (
        <WrappedComponent
          documentType={this.props.documentType}
          formattedFields={formattedFields}
          {...this.props}
        />
      );
    }
  }

  StaticBuilderSetup.defaultProps = {
    fields: [],
  };

  StaticBuilderSetup.propTypes = {
    documentType: PropTypes.string.isRequired,
    fields: PropTypes.arrayOf(PropTypes.shape({
      id: PropTypes.string,
      label: PropTypes.string,
      options: PropTypes.oneOfType([
        PropTypes.arrayOf(
          PropTypes.shape({
            text: PropTypes.string,
            value: PropTypes.string,
          }),
        ),
        PropTypes.string,
      ]),
      type: PropTypes.string,
      info: PropTypes.string,
    })),
    sectionContent: CustomPropTypes.shapeWithStringValues.isRequired,
  };

  return StaticBuilderSetup;
}



// WEBPACK FOOTER //
// ./src-react/StaticBuilder/hocs/StaticBuilderSetup.jsx